import React, { useState, useEffect } from "react";
import axios from "axios";

const AssetEdit = ({
  tokenStorage,
  openProfile,
  setOpenProfile,
  assetId,
  baseImageURL,
}) => {
  const baseAPI = process.env.REACT_APP_API_URL;

  const [asset, setAsset] = useState({
    Tseed: assetId,
    Is_Active: "",
    Is_Available: "",
    product_type: "",
    product_name: "",
    product_brand: "",
    product_config: "",
    product_warranty: "",
    Image: "",
    product_serial_number: "",
    current_owner: "",
    date_of_purchase: "",
    date_of_issue: "",
    date_of_return: "",
    password: "",
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [ownerData, setOwnerData] = useState([]);
  const [showhistory, setShowhistory] = useState(false);
  const [isAssetResponse, setIsAssetResponse] = useState([]);
  const [ProfilePicImg, setProfilePicImg] = useState(null);
  const [assetHistory, setAssetHistory] = useState([]);

  useEffect(() => {
    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (storedToken) {
      axios
        .get(`${baseAPI}adminget/GetAllAssets?Tseed=${assetId}`, {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        })
        .then((response) => {
          setIsAssetResponse(response.data.data[0]);
          setProfilePicImg(
            `${baseImageURL}Images/ProfilePics/${response.data.data[0].Image}`
          );
          const fetchedAsset = response.data.data[0];
          const assetWithAge = {
            ...fetchedAsset,
            asset_age: calculateAssetAge(fetchedAsset.date_of_purchase),
            current_owner: fetchedAsset.current_owner || "",
          };
          setAsset(assetWithAge);
        })
        .catch((error) => {
          console.error("Error fetching asset details:", error);
        });
      axios
        .get(
          `${baseAPI}adminget/GETEmployee?employeeID=&desg_id=0&dept_id=0&region_id=0&meal_Preference=&status=&location=`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        )
        .then((response) => {
          setOwnerData(response.data.data);
        })
        .catch((error) => {
          console.error("Error fetching employee data for owners:", error);
        });
    }
  }, [assetId, baseAPI]);

  const calculateAssetAge = (purchaseDate) => {
    if (!purchaseDate) return "N/A";

    const today = new Date();
    const purchase = new Date(purchaseDate);

    let years = today.getFullYear() - purchase.getFullYear();
    let months = today.getMonth() - purchase.getMonth();
    let days = today.getDate() - purchase.getDate();

    if (months < 0 || (months === 0 && days < 0)) {
      years--; // Adjust the year if the current month/day hasn't passed
    }

    if (months < 0) {
      months += 12;
    }

    if (days < 0) {
      const prevMonth = new Date(today.getFullYear(), today.getMonth(), 0);
      days += prevMonth.getDate();
      months--;
    }

    return `${years} year(s), ${months} month(s), ${days} day(s)`;
  };

  const fetchAssetHistory = async () => {
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      const response = await axios.get(
        `${baseAPI}adminget/GetAssetsHistory?Tseed=` + assetId,
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
      setAssetHistory(response.data.data);
      setShowhistory((prev) => !prev); // Toggle visibility
    } catch (error) {
      console.error("Error fetching asset history:", error);
    }
  };

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const options = {
      day: "numeric",
      month: "short",
      year: "numeric",
    };

    const formattedDate = new Date(dateString).toLocaleString("en-US", options);
    return formattedDate;
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const storedToken = JSON.parse(localStorage.getItem("token"));
    if (!storedToken) {
      alert("User is not authenticated.");
      return;
    }

    try {
      await axios.post(`${baseAPI}adminpost/AddOrUpdateAsset`, asset, {
        headers: {
          Authorization: `Bearer ${storedToken}`,
        },
      });

      setOpenProfile(!setOpenProfile);
      setAsset({
        Is_Active: "",
        product_type: "",
        product_name: "",
        product_brand: "",
        product_config: "",
        product_warranty: "",
        Image: "",
        product_serial_number: "",
        current_owner: "",
        date_of_purchase: "",
        date_of_issue: "",
        date_of_return: "",
        password: "",
      });
      tokenStorage();
      alert("Asset updated successfully.");
    } catch (error) {
      console.error("Error updating asset:", error);
    }
  };

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "ProfilePic") {
      const file = files[0];
      if (file) {
        const allowedTypes = ["image/jpeg", "image/png"];
        if (!allowedTypes.includes(file.type)) {
          alert("Only JPG and PNG files are allowed.");
          return;
        }
        getUpdatedImage(file, name);
      }
    }

    if (name === "Is_Available" && value === 1) {
      setAsset((prevData) => ({
        ...prevData,
        [name]: value,
        current_owner: "", // Reset Assigned To field
        date_of_issue: "", // Optionally reset date_of_issue
        date_of_return: "", // Optionally reset date_of_return
      }));
      return; // Exit early to avoid redundant state updates
    }

    if (name === "date_of_issue") {
      const dateOfPurchase = new Date(asset.date_of_purchase);
      const dateOfIssue = new Date(value);

      if (dateOfIssue < dateOfPurchase) {
        alert(
          "The date of issue must be greater than or equal to the date of purchase."
        );
        setAsset((prevData) => ({
          ...prevData,
          [name]: "", // Reset the date_of_issue value
        }));
        return;
      }
    }

    // date of return should be greater than date of issue
    if (name === "date_of_return") {
      if (new Date(value) <= new Date(asset.date_of_issue)) {
        alert("Date of return must be greater than the date of issue.");
        setAsset((prevData) => ({
          ...prevData,
          [name]: "", // Reset the date_of_return
        }));
        return;
      }
    }

    setAsset((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  function getUpdatedImage(file, name) {
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const imageData = reader.result;
        setAsset((prevItem) => ({
          ...prevItem,
          [name]: imageData,
        }));
        setProfilePicImg(imageData);
      };

      reader.readAsDataURL(file);
    }
  }

  return (
    <div className="container-fluid">
      <br />
      <div
        className="employeeDetail"
        style={{ backgroundColor: "#fcfcfc", marginBottom: "2rem" }}
      >
        <div
          className="employeeDetailHeader"
          style={{ backgroundColor: "#fcfcfc" }}
        >
          <div
            className="employeeNameAndImage"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              backgroundColor: "#fcfcfc",
              marginBottom: "2rem",
            }}
          >
            <div
              style={{
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "#fcfcfc",
                width: "5rem",
                height: "5rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                border: "1px solid #ddd",
              }}
            >
              {asset.Image && asset.Image.trim() !== "" ? (
                <img
                  alt="Asset"
                  src={ProfilePicImg}
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <span style={{ fontSize: "12px", color: "#878787" }}>
                  No Image
                </span>
              )}
            </div>

            <div className="employeeName">
              <h1
                style={{
                  fontSize: "20px",
                  margin: 0,
                  color: "#6A6A6A",
                  fontWeight: "700",
                }}
              >
                {asset.product_config || "N/A"}
              </h1>
              <span
                style={{
                  color: "#878787",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Serial No: {asset.product_serial_number || "N/A"}
              </span>
            </div>
          </div>

          <div className="ClearTab" style={{ display: "flex", gap: "10px" }}>
            <button
              onClick={(e) => {
                if (isEditMode) {
                  handleSubmit(e); // Pass the event to handleSubmit when Save is clicked
                } else {
                  setOpenProfile(!setOpenProfile); // Close the tab when Close Tab is clicked
                }
              }}
              className={isEditMode ? "saveButton" : "closeTabButton"}
            >
              {isEditMode ? "Save" : "Close Tab"}
            </button>
            <button
              className={isEditMode ? "CancelButton" : "editButton"}
              onClick={toggleEditMode}
            >
              {isEditMode ? "Cancel" : "Edit"}
            </button>
          </div>
        </div>

        {/*   ----------------------------------------------------------------------------------------------------------------*/}

        {isEditMode ? (
          <form
            className="asset-form"
            onSubmit={handleSubmit}
            style={{ backgroundColor: "#fcfcfc" }}
          >
            <table style={{ width: "100%", backgroundColor: "#fcfcfc" }}>
              <tr style={{ backgroundColor: "#fcfcfc", color: "#A0A0A0" }}>
                <td>Product Type</td>
                <td>Product Name</td>
                <td>Product Make/Brand</td>
              </tr>

              <tr style={{ backgroundColor: "#fcfcfc" }}>
                <td>
                  <input
                    name="product_type"
                    value={asset.product_type}
                    placeholder="Enter Description"
                    onChange={handleChange}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      backgroundColor: "#fafafa",
                      color: "#6A6A6A",
                    }}
                  />
                </td>

                <td>
                  <input
                    name="product_name"
                    value={asset.product_name}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      backgroundColor: "#fcfcfc",
                      color: "#6A6A6A",
                    }}
                  />
                </td>

                <td>
                  <input
                    name="product_brand"
                    value={asset.product_brand}
                    placeholder="Enter Brand"
                    onChange={handleChange}
                    readOnly
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      backgroundColor: "#fafafa",
                      color: "#6A6A6A",
                    }}
                  />
                </td>
              </tr>
              <br />
              <tr style={{ backgroundColor: "#fcfcfc", color: "#A0A0A0" }}>
                <td>Product Configuration</td>
                <td>Product Warranty</td>
                <td>Product Image</td>
              </tr>

              <tr style={{}}>
                <td>
                  <input
                    name="product_config"
                    value={asset.product_config}
                    readOnly
                    placeholder="Enter Description"
                    onChange={handleChange}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      backgroundColor: "#fcfcfc",
                      color: "#6A6A6A",
                    }}
                  />
                </td>

                <td>
                  <input
                    name="product_warranty"
                    value={asset.product_warranty}
                    readOnly
                    placeholder="Enter Description"
                    onChange={handleChange}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      backgroundColor: "#fcfcfc",
                      color: "#6A6A6A",
                    }}
                  />
                </td>

                <td>
                  {asset.Image && asset.Image.trim() !== "" ? (
                    <img
                      alt="Asset"
                      readOnly
                      src={ProfilePicImg}
                      style={{
                        width: "5rem",
                        height: "5rem",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <span style={{ fontSize: "12px", color: "#878787" }}>
                      No Image
                    </span>
                  )}
                </td>
              </tr>
              <br />

              <tr style={{ backgroundColor: "#fcfcfc", color: "#A0A0A0" }}>
                <td>Product Serial Number</td>
                <td>Assigned To</td>
                <td>Current Status</td>
              </tr>
              <tr style={{ backgroundColor: "#fcfcfc" }}>
                <td>
                  <input
                    name="product_serial_number"
                    value={asset.product_serial_number}
                    placeholder="Enter Serial Number"
                    onChange={handleChange}
                    readOnly
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      backgroundColor: "#fafafa",
                      color: "#6A6A6A",
                    }}
                  />
                </td>
                <td>
                  <td>
                    <select
                      name="current_owner"
                      value={asset.current_owner}
                      onChange={handleChange}
                      disabled={isAssetResponse.Is_Active === 0}
                      style={{
                        fontFamily: "'Montserrat', sans-serif",
                        backgroundColor: "#fafafa",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        width: "15rem",
                        color: "#6A6A6A",
                      }}
                      className="form-control"
                    >
                      <option value="">Select Owner</option>
                      {ownerData.map((owner) => (
                        <option key={owner.ID} value={owner.name}>
                          {owner.name}
                        </option>
                      ))}
                    </select>
                  </td>
                </td>
                <td>
                  <select
                    name="Is_Active"
                    value={asset.Is_Active}
                    onChange={handleChange}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      fontSize: "14px",
                      padding: "10px",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      backgroundColor: "#fafafa",
                      color: "#6A6A6A",
                    }}
                  >
                    <option value="1">Active</option>
                    <option value="0">Inactive</option>
                  </select>
                </td>
              </tr>
              <br />

              <tr style={{ backgroundColor: "#fcfcfc", color: "#A0A0A0" }}>
                <td>Date of Purchase</td>
                <td>Date of Issue</td>
                <td>Date of Return</td>
              </tr>

              <tr style={{ backgroundColor: "#fcfcfc", color: "#A0A0A0" }}>
                <td>
                  <label>{formatDate(asset.date_of_purchase)}</label>
                </td>
                <td>
                  <input
                    type="date"
                    name="date_of_issue"
                    className="form-control"
                    value={formatDateForInput(asset.date_of_issue)}
                    min={asset.date_of_purchase || ""}
                    onChange={handleChange}
                    disabled={isAssetResponse.Is_Active === 0 || isAssetResponse.date_of_issue}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      backgroundColor: "#fafafa",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      color: "#6A6A6A",
                    }}
                  />
                </td>
                <td>
                  <input
                    type="date"
                    name="date_of_return"
                    className="form-control"
                    value={formatDateForInput(asset.date_of_return)}
                    disabled={
                      !isAssetResponse.current_owner ||
                      !isAssetResponse.date_of_issue ||
                      isAssetResponse.Is_Active === 0
                    }
                    onChange={handleChange}
                    style={{
                      fontFamily: "'Montserrat', sans-serif",
                      backgroundColor: "#fafafa",
                      border: "1px solid #ccc",
                      borderRadius: "5px",
                      width: "15rem",
                      color: "#6A6A6A",
                    }}
                  />
                </td>
              </tr>
              <br />
              <tr style={{ backgroundColor: "#fcfcfc", color: "#A0A0A0" }}>
                <td></td>
                <td></td>
                <td></td>
              </tr>

              <tr style={{ backgroundColor: "#fcfcfc" }}>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            </table>
            <br />
            <hr />
            <div
              className="reset-addAsset-button"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                backgroundColor: "#fafafa",
              }}
            >
              <button
                type="submit"
                style={{
                  backgroundColor: "#5B489D",
                  color: "white",
                }}
                onClick={handleSubmit}
              >
                {asset.current_owner ? "Change Owner" : "Add Employee"}
              </button>
            </div>
          </form>
        ) : (
          // --------------Display mode---------------//

          <table style={{ width: "100%", marginTop: "2rem" }}>
            <tr
              style={{ color: "#A0A0A0", fontWeight: "500", fontSize: "18px" }}
            >
              <td>Product Type</td>
              <td>Product Name</td>
              <td>Product Make/Brand</td>
            </tr>

            <tr
              style={{ color: "#6A6A6A", fontWeight: "600", fontSize: "16px" }}
            >
              <td>{asset.product_type}</td>
              <td>{asset.product_name}</td>
              <td>{asset.product_brand}</td>
            </tr>

            <br />

            <tr style={{ color: "#A0A0A0", fontSize: "18px" }}>
              <td>Product Configuration</td>
              <td>Product Warranty</td>
              <td>Product Image</td>
            </tr>

            <tr
              style={{ color: "#6A6A6A", fontWeight: "600", fontSize: "16px" }}
            >
              <td>{asset.product_config}</td>
              <td>{asset.product_warranty}</td>
              <td>
                {asset.Image && asset.Image.trim() !== "" ? (
                  <img
                    alt="assetImage"
                    src={ProfilePicImg}
                    style={{ height: "5rem", width: "5rem" }}
                  />
                ) : (
                  <img alt="Not Found " src="" />
                )}
              </td>
            </tr>

            <br />

            <tr style={{ color: "#A0A0A0", fontSize: "18px" }}>
              <td>Product Serial Number</td>
              <td>Assigned To</td>
              <td>Current Status</td>
            </tr>
            <tr
              style={{ color: "#6A6A6A", fontWeight: "600", fontSize: "16px" }}
            >
              <td>{asset.product_serial_number}</td>
              <td>
                {asset.Is_Available === 1 || asset.Is_Active === 0
                  ? "N/A"
                  : asset.current_owner}
              </td>
              <td>{asset.Is_Active === 1 ? "Active" : "Inactive"}</td>
            </tr>

            <br />

            <tr style={{ color: "#A0A0A0", fontSize: "18px" }}>
              <td>Date of Purchase</td>
              <td>Date of Issue</td>
              <td>Date of Return</td>
            </tr>

            <tr
              style={{ color: "#6A6A6A", fontWeight: "600", fontSize: "16px" }}
            >
              <td> {formatDate(asset.date_of_purchase)}</td>
              <td>
                {asset.Is_Available === 1 || asset.Is_Active === 0
                  ? "N/A"
                  : formatDate(asset.date_of_issue)}
              </td>
              <td>
                {asset.Is_Available === 1 || asset.Is_Active === 0
                  ? "N/A"
                  : formatDate(asset.date_of_return)}
              </td>
            </tr>
            <br />

            <tr style={{ color: "#A0A0A0", fontSize: "18px" }}>
              <td>Availablity</td>
              <td>Asset Age</td>
              <td>Show Asset Assigned History</td>
            </tr>

            <tr
              style={{ color: "#6A6A6A", fontWeight: "600", fontSize: "16px" }}
            >
              <td>
                {" "}
                <td>{asset.Is_Available ? "Available" : "Not Available"}</td>
              </td>
              <td>{asset.asset_age}</td>
              <td>
                <button
                  style={{ height: "40px", width: "120px" }}
                  onClick={fetchAssetHistory}
                >
                  {showhistory ? "Hide History" : "Show History"}
                </button>
              </td>
            </tr>
          </table>
        )}
        {showhistory && (
          <table
            style={{
              color: "#A0A0A0",
              fontWeight: "500",
              fontSize: "18px",
              marginTop: "4rem",
            }}
          >
            <thead>
              <tr
                style={{
                  color: "#6A6A6A",
                  fontWeight: "600",
                  fontSize: "16px",
                }}
              >
                <th>Assigned To</th>
                <th>Asset Name</th>
                <th>Description</th>
                <th>Date of Issue</th>
                <th>Date of Return</th>
              </tr>
            </thead>
            <tbody>
              {assetHistory && assetHistory.length > 0 ? (
                assetHistory.map((history, index) => (
                  <tr
                    key={index}
                    style={{
                      color: "#A0A0A0",
                      fontWeight: "500",
                      fontSize: "18px",
                      marginBottom: "1rem",
                    }}
                  >
                    <td style={{ marginBottom: "1rem" }}>
                      {history.assigned_to ?? "null"}
                    </td>
                    <td>{history.product_name ?? "null"}</td>
                    <td>{history.product_config ?? "null"}</td>
                    <td>{formatDate(history.date_of_issue) ?? "null"}</td>
                    <td>
                      {history.date_of_return
                        ? formatDate(history.date_of_return)
                        : "Not Returned yet"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="5"
                    style={{ textAlign: "center", color: "#6A6A6A" }}
                  >
                    No history available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AssetEdit;
